import { createSelector } from 'reselect'
import { Map } from 'immutable'
import * as constants from './constants'

const root = state => state.get('embed')

export const embedLoadFailed = createSelector(root, root => root.get('status') === constants.FETCH_EMBED_FAILED)

export const embedLoaded = createSelector(root, root => {
  return [constants.FETCH_EMBED_SUCCESS, constants.PATCH_EMBED_SUCCESS].includes(root.get('status'))
})


export const embedFetchPending = state => state.getIn(['embed', 'status']) === constants.FETCH_EMBED_PENDING
export const embedPatchPending = createSelector(root, root => {
  return root.get('status') === constants.PATCH_EMBED_PENDING
})
export const embedPatchSuccess = createSelector(root, root => root.get('status') === constants.PATCH_EMBED_SUCCESS)
export const embedNotFetched = state => !state.getIn(['embed', 'status'])
export const getRawEmbedData = state => root(state).get('data')

export const getEmbedId = state => root(state).getIn(['data', 'id'])
export const getOrgId = state => root(state).getIn(['data', 'orgId'])
export const getOrgName = state => root(state).getIn(['data', 'configuration', 'organizationName'])
export const getOrgShowBranding = state => root(state).getIn(['data', 'configuration', 'showBranding'])
export const getRawEmbedConfiguration = state => root(state).getIn(['data', 'configuration'])
export const getEmbedConfig = createSelector(
  getRawEmbedConfiguration,
  config => (config ? config.toJS() : null)
)

export const orgLocale = state => root(state).getIn(['data', 'configuration', 'locale'])

export const orgUrl = state => root(state).getIn(['data', 'configuration', 'organizationUrl'])
export const orgTwitterLink = state => root(state).getIn(['data', 'configuration', 'organizationTwitterLink'])
export const orgLinkedinLink = state =>
  root(state).getIn(['data', 'configuration', 'organizationLinkedinLink'])
export const orgFacebookLink = state =>
  root(state).getIn(['data', 'configuration', 'organizationFacebookLink'])

export const orgAddress = createSelector(getRawEmbedConfiguration, config =>
  (config || Map()).get('organizationAddress')
)

export const isChatEnabled = state => root(state).getIn(['data', 'configuration', 'chatEnabled'], false)
export const isShowWidgetIfConvoHistoryEnabled = state => root(state).getIn(['data', 'configuration', 'theme', 'enableChatIfConversationHistory'], false)
export const theme = state => root(state).getIn(['data', 'configuration', 'theme'], Map())
export const showUnfurl = createSelector(theme, theme => theme.get('showUnfurl', true))
export const orgTimezone = createSelector(theme, theme => theme.get('timezone', 'America/New_York'))
export const backgroundColor = createSelector(theme, theme => {
  if (theme) {
    return `#${theme.get('backgroundColor')}`
  }
})

export const logoUrl = createSelector(theme, theme => theme.get('logoUrl'))
export const defaultInboxId = createSelector(root, root => root.getIn(['data', 'configuration', 'inboxId']))
const getGates = createSelector(getRawEmbedConfiguration, config => config && config.get('gates'))
export const makeEmbedHasGate = gate => createSelector(embedLoaded, getGates, (embedLoaded, gates) => embedLoaded && gates && gates.get(gate))

const locale = createSelector(getEmbedConfig, embed => embed && embed.locale)
export const isGlobalLocale = createSelector(locale, locale !== 'en')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/embed/selectors.js